<template>
    <el-row v-if="amReady" class="mb-3">
        <div class="m-0 p-0 mb-5 border-bottom" v-if="formHeader">
            <h5>{{this.getFormTitle}}</h5>
        </div>
        <div class="mb-2" v-else></div>

        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="control"
                :field_span="22"
            :label_span="22"
                field_mark="required"
                label="cli_number"
                name="cli_number"
                placeholder="+1 123 456 789"
                rules="required"></dg-text-field>
        </el-col>


        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-select-field
                :control="control"
                :field_span="22"
            :label_span="22"
                :options="dropDownList"
                :translateLabels="false"
                field_mark="required"
                label="destination"
                name="destination"
                placeholder="Canada"
                rules="required"></dg-select-field>
        </el-col>

        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
                <dg-auto-complete-field
                    :control="control"
                    :field_span="22"
            :label_span="22"
                    :suggestions="categoriesSuggestion"
                    :translateLabel="false"
                    field_mark="required"
                    label="category"
                    name="category"
                    rules="required"></dg-auto-complete-field>
        </el-col>

        <el-col :span="24" class="mt-2 border-top">
            <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
                <dg-label-field class="error-field-validate-message" label="fields_do_not_match_the_required_criteria"
                                v-show="!this.validData"></dg-label-field>
            </el-col>
            <el-col :span="12" class="pt-3 text-right">
                <dg-confirm-button
                    v-if="editMode"
                    class="mr-2"
                    :loading="requestOn"
                    :translate="false"
                    fieldSize="mini"
                    :onConfirm="removeAction"
                    title="sure to removing this record ?"
                    popIcon="el-icon-delete"
                    confirmButtonType="danger"
                    text="remove"
                    type="danger"
                    icon="el-icon-delete"></dg-confirm-button>

                <dg-button class="mr-2" v-if="editable && editMode" text="cancel" type="warning" icon="el-icon-close" fieldSize="mini" :click="cancelEditable"></dg-button>
                <dg-button v-if="!editable && editMode" text="edit" type="success" icon="el-icon-edit" fieldSize="mini" :click="changeEditable"></dg-button>
                <dg-confirm-button
                    v-if="editable"
                    :loading="requestOn"
                    :translate="false"
                    fieldSize="mini"
                    :onConfirm="createModule"
                    :text="actionButtonLabel"
                    :type="actionButtonType"
                    :icon="actionButtonIcon"></dg-confirm-button>
            </el-col>
        </el-col>
    </el-row>
</template>

<script>


import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import {notify} from '@/system-services/notify.js'

export default {
  mixins: [fieldController],
        props: {
            formHeader: {
                required: false,
                default: false
            },
            formTitle: {
                required: false
            },
            editMode: {
                required: true,
                type: Boolean
            },
            onEditCallback: {
                required: false
            },
            onCreateCallback: {
                required: false
            },
        },
        data() {
            return {
                control: this,
                amReady: true,
                requestOn: false,
                editable: !this.editMode,
                dropDownList: [],
                module: {
                    ...module
                },
                categoriesSuggestion: [
                  { "value": "vue", "link": "https://github.com/vuejs/vue" },
                  { "value": "element", "link": "https://github.com/ElemeFE/element" },
                  { "value": "cooking", "link": "https://github.com/ElemeFE/cooking" },
                  { "value": "mint-ui", "link": "https://github.com/ElemeFE/mint-ui" },
                  { "value": "vuex", "link": "https://github.com/vuejs/vuex" },
                  { "value": "vue-router", "link": "https://github.com/vuejs/vue-router" },
                  { "value": "babel", "link": "https://github.com/babel/babel" }
                ]
            }
        },
        computed: {
            //...$mapState('voip-lcr-api', ['openedEntity']),
            ...$mapState('ajaxManager', ['loadingRequests']),
            getFormTitle: function () {
                if (this.formTitle) {
                    return this.formTitle
                } else {
                    return ((!this.editMode)? this.$ml.get('create') : this.$ml.get('edit') ) + ' ' + this.module.info.caption
                }
            },
            actionButtonLabel: function () {
                if (!this.editMode) {
                    return 'create';
                } else {
                    return 'save'
                }
            },
            actionButtonIcon: function () {
                if (!this.editMode) {
                    return 'el-icon-plus';
                } else {
                    return 'el-icon-check'
                }
            },
            actionButtonType: function () {
                if (!this.validData) {
                    return 'danger btn-small';
                } else {
                    if (!this.editMode) {
                        return 'primary app-bg-primary';
                    } else {
                        return 'primary'
                    }
                }
            }
        },
        beforeMount() {
            this.getEntityDropDownList().then( (r) => {
              this.dropDownList = r
            })
        },
        methods: {
            ...$mapActions('voip-lcr-state', ['addEntity']),
            ...$mapActions('voip-lcr-api', { getEntityDropDownList: 'getDropDownList'}),
            cancelEditable () {
                let context = this
                this.amReady = false
                this.editable = false
                $vue.nextTick(() => {
                        context.amReady = true
                })
            },
            changeEditable () {
                this.editable = !this.editable
            },
            removeAction(params) {
                let cxt = this
                this.requestOn = true
                this.$store.dispatch(this.module.info.name + '-api/remove', {id: this.recordId}).then(response => {
                    notify({
                        type: 'success',
                        title: this.$ml.get('deleted'),
                        message: '',
                        position: 'topRight',
                        close: false,
                        timeout: 1900,
                        animateInside: true,
                    });
                    cxt.amReady = false
                })
            },
            createModule() {
                this.validateFields().then(result => {
                        if (!result) return

                        this.requestOn = true
                        let context = this;
                        let data = {data: this.dataModel};
                        if (this.editMode) {
                            data.id = this.dataToBind.id;
                        }

                        let api = (this.editMode) ? 'update' : 'create';
                        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
                            this.amReady = false
                            notify({
                                type: 'success',
                                title: this.$ml.get('successfully'),
                                message: '',
                                position: 'topRight',
                                close: false,
                                timeout: 1900,
                                animateInside: true,
                            });

                            $vue.nextTick(() => {
                                context.amReady = true
                                context.requestOn = false
                                if (context.editMode) {
                                if (context.onEditCallback) {
                                    context.onEditCallback(response.data)
                                    }
                                } else {
                                    if (context.onCreateCallback) {
                                        context.onCreateCallback(response.data)
                                    }
                                }
                            })
                            // this.$router.push({ name: this.module.stateName + '-module-list', params: {}}).then( response => {})
                        }).catch(error => {
                            console.log('catch error', error)
                            this.setfieldsErrorMessage({
                                fieldsErrors: error.response.data
                            });
                        }).finally( () => {
                          this.requestOn = false
                        })

                })
            }
        }
    }
</script>
